module.exports = __webpack_public_path__ + "img/bg_las-vegas-market_tourism.a0d5fc5e.jpg";